/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../deprecated/LegacyViewControllersAPI',
	'../../dashboard/layout/LayoutController',
	'../../dashboard/loader/WidgetLoader'
], ($, APIFactory, LegacyViewControllersAPI, LayoutController, WidgetLoader) => {

	/**
	 * @implements LegacyViewControllersAPI
	 * @hideconstructor
	 */
	class LegacyViewControllers {

		constructor({ environment, layoutController }) {
			this._widgetLoader = layoutController && layoutController.widgetLoader || this._createWidgetLoader(environment);
			this._layoutController =  layoutController || this._createLayoutController(environment);
		}

		getAPI() {
			if(!this._api) {
				this._api = APIFactory.createAPI(this, [ LegacyViewControllersAPI ]);
			}
			return this._api;
		}

		getLayoutController() {
			return this._layoutController;
		}

		getWidgetLoader() {
			return this._widgetLoader;
		}

		_createWidgetLoader(env) {
			return new WidgetLoader({
				glassContext: env.glassContext,
				services: env.serviceRegistry,
				appSettings: {},
				dashboardApi: env.dashboardApi,
				eventRouter: env.eventRouter,
				widgetRegistry: env.widgetRegistry,
				loadedWidgets: {},
				boardModel: env.boardModel,
				contentFeatureLoader: env.internalCanvas,
				canvas: env.canvas
			});
		}

		_createLayoutController(env) {
			return new LayoutController({
				glassContext: env.glassContext,
				services: env.serviceRegistry,
				appSettings: {},
				contentFeatureLoader: env.internalCanvas,
				dashboardApi: env.dashboardApi,
				eventRouter:  env.eventRouter,
				$el: $('body'),
				boardModel: env.boardModel,
				widgetLoader: this._widgetLoader,
				layoutExtensions: env.layoutExtensions,
				gatewayUrl: 'v1',
				cdnUrl: '',
				canvas: env.canvas
			});
		}

		destroy() {
			this.getWidgetLoader().cleanup();
			this.getLayoutController().destroy();
		}
	}

	return LegacyViewControllers;
});
